export function isAnimatedUrl(url: string) {
  return url.endsWith(".gif") || url.endsWith(".webm") || url.endsWith(".mp4");
}
